/**
 * ODDFISH — Our Work page (case study grid reveal only)
 * Hero scroll/hide: oddfish-hero.liquid (shared with Agency, Services, Team, etc.)
 */
(function () {
  "use strict";

  var REDUCED_MOTION = window.matchMedia("(prefers-reduced-motion: reduce)");

  function prefersReducedMotion() {
    return REDUCED_MOTION.matches;
  }

  function isDesignMode() {
    if (window.Shopify && window.Shopify.designMode) return true;

    try {
      if (window.parent !== window && window.parent.Shopify && window.parent.Shopify.designMode) {
        return true;
      }
    } catch (error) {
      /* cross-origin iframe */
    }

    return (
      document.documentElement.classList.contains("shopify-design-mode") ||
      (document.body && document.body.classList.contains("shopify-design-mode")) ||
      /[?&]oseid=/.test(window.location.search)
    );
  }

  function revealGrid(page) {
    page.querySelectorAll(".case_studies").forEach(function (grid) {
      grid.classList.add("is-visible");
    });
  }

  function initScrollSections(page) {
    if (prefersReducedMotion() || isDesignMode()) return;

    var ticking = false;

    function handleScroll() {
      var windowBottom = window.scrollY + window.innerHeight;

      page.querySelectorAll(".animate").forEach(function (section) {
        var sectionBottom = section.offsetTop + section.offsetHeight - 50;
        if (windowBottom > sectionBottom) {
          section.classList.add("scrolled");
        }
      });
    }

    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            handleScroll();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    window.addEventListener("resize", handleScroll, { passive: true });
    handleScroll();
  }

  function initWorkPage(root) {
    var page = (root && root.querySelector ? root.querySelector(".oddfish-work-page") : null) ||
      document.querySelector(".oddfish-work-page");
    if (!page) return;
    if (page.dataset.oddfishWorkInit === "true") return;

    page.dataset.oddfishWorkInit = "true";
    page.classList.add("js-ready");
    revealGrid(page);
    initScrollSections(page);
  }

  function resetWorkPage(root) {
    var page = root && root.querySelector ? root.querySelector(".oddfish-work-page") : null;
    if (!page) return;
    delete page.dataset.oddfishWorkInit;
    page.classList.remove("js-ready");
    page.querySelectorAll(".case_studies").forEach(function (grid) {
      grid.classList.remove("is-visible");
    });
    initWorkPage(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initWorkPage(document);
    });
  } else {
    initWorkPage(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (event.target && event.target.querySelector(".oddfish-work-page")) {
      resetWorkPage(event.target);
    }
  });

  REDUCED_MOTION.addEventListener("change", function () {
    var page = document.querySelector(".oddfish-work-page");
    if (!page) return;
    delete page.dataset.oddfishWorkInit;
    page.classList.remove("js-ready");
    initWorkPage(document);
  });
})();
